export const getString = (value) => {
    return value != null ? value : '';
}

export const getNumber = (value) => {
    return value != null ? value : null;
}